/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon12Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      viewBox={"0 0 1024 1024"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M738.16 231.35c-155-124.91-381.91-100.51-506.82 54.49s-100.51 381.91 54.49 506.82 381.91 100.51 506.82-54.49 100.51-381.91-54.49-506.82m-89.03 132.71-92.94 365.79c-3.59 14.14-23.04 15.75-28.91 2.39l-64.81-147.52a15.34 15.34 0 0 0-11-8.86l-157.92-31.97c-14.3-2.9-16.86-22.24-3.81-28.76l337.67-168.57c11.75-5.86 24.95 4.78 21.72 17.5"
        }
      ></path>
    </svg>
  );
}

export default Icon12Icon;
/* prettier-ignore-end */
